module.exports = __webpack_public_path__ + "static/media/VaderPay_QR_WH.7ba3e269.svg";